import { connect } from 'react-redux'

import NetworkProvider from './NetworkProvider'

const mapStateToProps = (state) => {
  return {
    sendingData: state.appReducer.sendingData
  }
}


export default connect(mapStateToProps)(NetworkProvider)
